<template>
  <div class="paySys-body" id="paySystem">
    <div class="paysys-box">
      <div class="paysys-all">
        <!-- 返回箭头 -->
        <div class="sys_back_icon" @click="backHistory()"></div>
        <!-- 大标题文字 -->
        <div class="paysys-title">{{$t('language.paySystem.payTitle')}}</div>
        <!-- 左右按钮 -->
        <div class="paySwitch" v-if="(!morePrivileges&&user.vip)||!user.vip">
          <div class="switch-all" v-if="!user.vip">
            <div class="switch-left" :class="clickIndex==0?'switch-click':''" @click="changeChoosePlan(0)">
              <span>{{$t('language.paySystem.limitedData')}}</span>
            </div>
            <div class="seitch-right" :class="clickIndex==1?'switch-click':''" @click="changeChoosePlan(1)">
              <span>{{$t('language.paySystem.unlimitedData')}}</span>
            </div>
          </div>
          <div class="switch-all" v-if="user.vip&&isActiveLoginType()">
            <div class="switch-left" :class="clickIndex==0?'switch-click':''" @click="changeChoosePlan(0)">
              <span>{{$t('language.paySystem.limitedData')}}</span>
            </div>
            <div class="seitch-right" :class="clickIndex==1?'switch-click':''" @click="changeChoosePlan(1)">
              <span>{{$t('language.paySystem.unlimitedData')}}</span>
            </div>
          </div>
          <div class="switch-all" v-if="user.vip&&!isActiveLoginType()">
            <div class="switch-left" v-if="user.payLevel>1" :class="clickIndex==1?'switch-click':''" @click="changeChoosePlan(1)">
              <span>{{$t('language.paySystem.toUnlimited')}}</span>
            </div>
            <div class="seitch-right" v-if="user.payLevel>1" :class="clickIndex==2?'switch-click':''" @click="changeChoosePlan(2)">
              <span>{{$t('language.paySystem.moreTraffic')}}</span>
            </div>
          </div>
          <!-- 月年切换(20260421:废弃改按钮，合并月年) -->
          <!-- <div class="paysys-cycle" v-if="(clickIndex==0&&!(user.vip&&isActiveLoginType()))">
            <div class="cycle-name" :class="checkCycleType==0?'check-cycle':''">{{$t('language.paySystem.monthly')}}</div>
            <div class="pay-scheme-cycle-btn" @click="checkPaySchemeCycle()">
              <img src="../../assets/images/paySystem/button_round.png" :style="checkCycleType==1?'float:right;':'float:left;'"> 
            </div>
            <div class="cycle-name-right" :class="checkCycleType==1?'check-cycle':''">{{$t('language.paySystem.annually')}}<div class="cycle-name-tips">{{$t('language.paySystem.save58')}}</div></div>
          </div> -->
        </div>

        <div ref="allBottom" class="paySys-bottom" :class="user.vip&&user.payLevel<=1?'paySys-bottom-unlimit':''">
          <div class="paysys-div-all">
            <paySchemeTab ref="payScheme" v-if="!user.vip&&clickIndex!=2"></paySchemeTab>
            <paySchemeTab ref="payScheme" v-if="user.vip&&nowScheme&&clickIndex!=2" :payScheme=nowScheme :index=-1></paySchemeTab>
            <paySchemeTab ref="payScheme" v-for="(allowScheme,index) in allowSchemes" :key="index" :payScheme=allowScheme :index=index :isLimit="clickIndex==0" :isVIP="user.vip" :isTraffic="clickIndex==2" :indexMax="allowSchemes.length"></paySchemeTab>
          </div>
        </div>
      </div>
  </div>
  <div class="task-buttom pay_task_buttom"></div>
    <bindEmailDialog ref="bindEmailDialog"></bindEmailDialog>
    <payDiffDialog ref="payDiffDialog"></payDiffDialog>
    <payErrorNoticeDialog ref="payErrorNoticeDialog"></payErrorNoticeDialog>
    <bindEmailJumpDialog ref="bindEmailJumpDialog"></bindEmailJumpDialog>
    <nowPaySchemeDialog ref="nowPaySchemeDialog"></nowPaySchemeDialog>
    <iosPayTipDialog ref="iosPayTipDialog"></iosPayTipDialog>
    <appNowPaySchemeDialog ref="appNowPaySchemeDialog"></appNowPaySchemeDialog>
    <userStarPopup ref="userStarPopup"></userStarPopup>
    <userStarJumpPopup ref="userStarJumpPopup"></userStarJumpPopup>
    <userStarFeedbackPopup ref="userStarFeedbackPopup"></userStarFeedbackPopup>
    <licenseShowDialog ref="licenseShowDialog" :subscrId="user.subscrId"></licenseShowDialog>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import paySchemeTab from '@/components/common/tabs/tabs_pay_system/tab_pay_scheme';
import googleAnalyticsUtil from "../../js/workspace/google_analytics_util.js";
import bindEmailDialog from '@/components/popup/pay_system_popups/bind_email_topay_popup';
import payDiffDialog from '@/components/popup/pay_system_popups/pay_diff_money_popup';
import payErrorNoticeDialog from '@/components/popup/pay_system_popups/pay_error_notice_popup';
import bindEmailJumpDialog from '@/components/popup/personal_center_popups/bind_email_popup';
import paySysUtils from "@/js/workspace/pay_system_util.js";
import getCurrencyUtils from '@/js/workspace/get_currency.js';
import upgradeItemUtils from '@/js/workspace/upgrade_item.js';
import nowPaySchemeDialog from '@/components/popup/pay_system_popups/now_pay_scheme_popups';//用户当前套餐信息弹窗
import iosPayTipDialog from '@/components/popup/pay_system_popups/ios_pay_tip_popups';//用户当前套餐信息弹窗
import appNowPaySchemeDialog from '@/components/popup/pay_system_popups/app_now_pay_scheme_popups';//用户当前套餐信息弹窗
import taskListUtils from "@/js/workspace/task_list_util.js";
import userStarPopup from "@/components/popup/task_list_popups/user_star_popup";
import userStarJumpPopup from "@/components/popup/task_list_popups/user_star_jump_popup";
import userStarFeedbackPopup from "@/components/popup/task_list_popups/user_star_feedback_popup";
//兑换码升级用户提示弹窗
import licenseShowDialog from '@/components/popup/personal_center_popups/license_show_popup';
export default {
  data () {
    return {
      newPayMoney:'',
      sendSubScribeRequest: true,//是否能向CB发送请求，true表示可以，false，表示不能向cb发送消息
      morePrivileges: false,
      user: commonUtils.getUser(),
      clickIndex: 0,
      usedTraffic: '',
      flow: '', //显示有限月定的流量包
      subscriptionTtem: {}, //存储用户当前订阅的项目
      nowData: [],
      requestNum: 0, //请求后端代码的次数
      checkCycleType: 1,//选中的付费周期类型0：月，1：年
      nowScheme: null,
      allSchemes: [],//全部可选套餐
      allowSchemes: [],//当前页面展示套餐
      dataJson: [{
        paySysName: this.$t('language.paySystem.threeMonth'),
        payMony: this.$t('language.popup.upgradeAccountPopup.free'),
        property: '',
        includes: [{
          name: this.$t('language.popup.upgradeAccountPopup.monthTraffic'),
          des: this.$t('language.popup.upgradeAccountPopup.freeDes')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.syncMode')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.offlineFree')
        },
         {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled'),
        }
        ],
        summary: ''
      }, {
        paySysName: this.$t('language.paySystem.limitedMonth'),
        payMony: '$9.9',
        flow: '150' + this.$t('language.paySystem.gb'),
        payType: 'Monthly',
        payLevel: 2,
        property: this.$t('language.paySystem.monthlyPayment'),
        productId: '214430',
        xMb: 14, //退款天数
        xPage: 'monthly2',
        includes: [{
          name: this.$t('language.paySystem.limitedTrafficMonth'),
          des: ''
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        }, 
         {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer'),
          des: ''
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport'),
          des: ''
        }],
        summary: {
          sname: this.$t('language.paySystem.billed'),
          sDes: this.$t('language.paySystem.subCould')
        }
      },
      {
        paySysName: this.$t('language.paySystem.YearlyUnlimited'),
        payMony: '$119.9',
        payType: 'Yearly',
        payLevel: 1,
        productId: "214433",
        xMb: 30, //退款天数
        xPage: 'yearly-un3',
        property: this.$t('language.paySystem.YearlyPaymentNine'),
        includes: [{
          name: this.$t('language.paySystem.foraYear')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        },
         {
          name: this.$t('language.cloudSync.realSync')
        },
         {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.noNeedPurchase')
        }
      },
      {
        paySysName: this.$t('language.rightTopBanner.lifeTimePlan'),
        payMony: '$239.4',
        payType: 'Lifetime',
        productId: '226093',
        xMb: 30, //退款天数
        xPage: 'life-un3',
        coupon: 'F3A-ZRG-133',
        payLevel: 1,
        specialOffer: true,
        oldPayMony: '$399.0',
        property: this.$t('language.paySystem.Onetime'),
        includes: [{
          name: this.$t('language.paySystem.unlimitedTraffic')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        },  {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.noNeedPurchase')
        }
      },
      ],
      freeOtherPlan: [{
        paySysName: this.$t('language.paySystem.threeMonth'),
        payMony: this.$t('language.popup.upgradeAccountPopup.free'),
        property: '',
        includes: [{
          name: this.$t('language.popup.upgradeAccountPopup.monthTraffic'),
          des: this.$t('language.popup.upgradeAccountPopup.freeDes')
        },  {
          name: this.$t('language.popup.upgradeAccountPopup.syncMode')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.offlineFree')
        }, {
          name: this.$t('language.cloudSync.realSync')
        },
         {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        },],
        summary: ''
      }, {
        paySysName: this.$t('language.paySystem.twoMonthree'),
        flow: '200' + this.$t('language.paySystem.gb'),
        payMony: '$24.9',
        payType: 'Quarterly',
        payLevel: 2,
        productId: '214431',
        xMb: 30, //退款天数
        xPage: 'quarterly2',
        property: this.$t('language.paySystem.QuarterlyPayment'),
        includes: [{
          name: this.$t('language.paySystem.twoMonTrafficthree')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        }, {
          name: this.$t('language.cloudSync.realSync')
        },
         {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.billed'),
          sDes: this.$t('language.paySystem.subCould')
        }
      },
      {
        paySysName: this.$t('language.paySystem.fourMOne'),
        flow: '400' + this.$t('language.paySystem.gb'),
        payMony: '$89.9',
        payType: 'Yearly',
        productId: '214432',
        xMb: 30, //退款天数
        xPage: 'yearly2',
        payLevel: 2,
        property: this.$t('language.paySystem.yearlyPayment'),
        includes: [{
          name: this.$t('language.paySystem.fourMTrafficOne')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        },  {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.billed'),
          sDes: this.$t('language.paySystem.subCould')
        }
      }
      ],
      limitedOtherPlan: [{ //流量包
        paySysName: '50' + this.$t('language.paySystem.gb'),
        payMony: '$5.9',
        eachGb: this.$t('language.paySystem.eachGbMoney') + this.$t('language.paySystem.gb'),
        payLevel: 3,
        productId: '214087',
        xMb: 14, //退款天数
        xPage: 'PTP',
        summary: this.$t('language.paySystem.validityData')
      },
      {
        paySysName: '100' + this.$t('language.paySystem.gb'),
        payMony: '$9.9',
        eachGb: this.$t('language.paySystem.eachGbMoneyT') + this.$t('language.paySystem.gb'),
        payLevel: 4,
        productId: '214088',
        xMb: 14, //退款天数
        xPage: 'PTN',
        summary: this.$t('language.paySystem.validityData')
      },
      ],
      monthlyUnlimited: {
        paySysName: this.$t('language.paySystem.monthlyUnlimited'),
        payMony: '$19.9',
        payType: 'Monthly',
        payLevel: 1,
        property: this.$t('language.paySystem.monthlyPayment'),
        includes: [{
          name: this.$t('language.paySystem.monthTraffic')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.moreSyncModes'),
          des: this.$t('language.popup.upgradeAccountPopup.syncSupported')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.offlinePremium')
        },  {
          name: this.$t('language.cloudSync.realSync')
        },
        {
          name: this.$t('language.popup.upgradeAccountPopup.scheduled')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferSpeed'),
          des: this.$t('language.popup.upgradeAccountPopup.greatlyIncreased')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.doubleSync'),
          des: this.$t('language.popup.upgradeAccountPopup.sameTime')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.filter'),
          des: this.$t('language.popup.upgradeAccountPopup.automatically')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.transferServer')
        }, {
          name: this.$t('language.popup.upgradeAccountPopup.customerSupport')
        }],
        summary: {
          sname: this.$t('language.paySystem.noNeedPurchase')
        }
      }
    }
  },
  mounted () {
    let that = this;
    let user = commonUtils.getUser();
    if (!user || !user.id) {
      this.$router.push('/turnLoginPage');
    }
    if(this.$route.path == '/mc_project/paySys') {
      this.initShowData(); //默认显示第一页
    }
    //2022新春活动限定繁体,活动开启时自动退回
    // if(this.$i18n.locale=="traditionalChinese"){
      // var isTimerExpired = commonUtils.getTimerExpired(commonstate.activityEndedTimer);
      // if(isTimerExpired){
      //   this.$router.push('/mc_project/paySysActivity');
      // }
    // }
    // window.addEventListener("setItem",function (e) {
    //   console.log(e.key)
    //   if(e.key=="user"){
    //     console.log(e.value);
    //   }
    // })
    // 用户好评弹窗（会员信息页面）
    if (this.$store.state.isShowUserStarReady) {
      // 下次不显示
      this.$store.state.isShowUserStarReady = false;
      this.$store.state.isShowUserStar = false;
      // 显示弹窗
      this.$refs.userStarPopup.isShowStarPopup = true;
      taskListUtils.userStarUpdateRequest({createReason:1,score:0,trustpilot:false,content:''});
    }
  },
  watch:{
    checkCycleType(newV,oldV){
      this.changeAllowSchemes();
    },
    clickIndex(newV,oldV){
      this.changeAllowSchemes();
    },
    '$store.state.updateUserSchems': function (newValue, oldValue) {
      if (newValue) {
        this.initShowData();
        this.$store.commit("setUpdateUserSchems", false);
      }
    },
  },
  components: {
    bindEmailDialog,
    payDiffDialog,
    payErrorNoticeDialog,
    bindEmailJumpDialog,
    paySchemeTab,
    nowPaySchemeDialog,
    iosPayTipDialog,
    appNowPaySchemeDialog,
    userStarPopup,
    userStarJumpPopup,
    userStarFeedbackPopup,
    licenseShowDialog,
  },
  methods: {
      isActiveLoginType(){
        if(this.nowScheme&&this.nowScheme.cartId){
          return  commonstate.activeCartIdList.includes(this.nowScheme.cartId);
        }
        return false;
      },
      getBottonWidth(){
      let result;
      switch (this.$i18n.locale) {
        case 'english':
          result = "240px";
          break;
        case 'deutsch':
          result = "280px";
          break;
        case 'france':
          result = "280px";
          break;
        case 'portuguese':
          result = "250px";
          break;
        case 'spanish':
          result =  "260px";
          break;
        case 'italian':
          result = "260px";
          break;
        case 'japanese':
          result = "280px";
          break;
        case 'traditionalChinese':
          result = "220px";
          break;
        case 'chinese':
          result = "220px";
          break;
      }
      return result;
      },
    getBackClass () {
      let result;
      switch (this.$i18n.locale) {
        case 'english':
          result = "back-en";
          break;
        case 'deutsch':
          result = "back-de";
          break;
        case 'france':
          result = "back-fr";
          break;
        case 'portuguese':
          result = "back-por";
          break;
        case 'spanish':
          result = "back-spa";
          break;
        case 'italian':
          result = "back-it";
          break;
        case 'japanese':
          result = "back-ja";
          break;
        case 'traditionalChinese':
          result = "back-tw";
          break;
        case 'chinese':
          result = "back-cn";
          break;
      }
      return result;
    },
    getTxtWidth (item, jIndex) {
      let result;
      if (item.productId == '226093' && this.clickIndex == 0 && !this.user.isvip) {
        result = 'questionTxtWidth-min';
      }
      return result;
    },
    //获取付款时间延后一个月的天数当月天数
    getCountDays () {
      var date = new Date(this.user.payTime);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var lastDay = new Date(year, month, 0).getDate()//获得是标准时间,需要getDate()获得天数
      return lastDay;
    },
    //获取季付的3个月天数
    getQuartlyDays () {
      var allTime;
      var d = new Date(this.user.payTime);
      var Year = d.getFullYear();
      var Month = d.getMonth() + 1;
      var DateL = d.getDate();
      var newMonth = Month + 2;
      var mydate = new Date(Year, newMonth, DateL);
      allTime = Math.ceil((mydate.getTime() - this.user.payTime) / (1000 * 60 * 60 * 24));
      return allTime;
    },
    //获取年份的天数
    getYearlylyDays () {
      var allTime;
      var d = new Date(this.user.payTime);
      var Year = d.getFullYear();
      var Month = d.getMonth();
      var DateL = d.getDate();
      var mydate = new Date(Year + 1, Month, DateL);
      allTime = Math.ceil((mydate.getTime() - this.user.payTime) / (1000 * 60 * 60 * 24));
      return allTime;
    },
    //实时修改当前展示套餐
    changeAllowSchemes(){
      this.allowSchemes = this.allSchemes[this.clickIndex];
    },
    changeChoosePlan (index) {
      this.clickIndex = index;
    },
    //根据条件筛选套餐
    filterVipSchemes(vipSchemes){
      if(!vipSchemes){
        return;
      }
      let limitedVip = [];//有限套餐
      let unlimitedVip = [];//无限套餐
      let flowPackage = [];//流量包
      vipSchemes.forEach(function (item,index) {
        if(item.level == 2){
          limitedVip.unshift(item);
        }else if(item.level == 1){
          unlimitedVip.push(item);
        }else if(item.level >= 3){
          flowPackage.push(item);
        }
      })

      this.allSchemes = [
        limitedVip,
        unlimitedVip,
        flowPackage
      ]
      this.$forceUpdate();
      this.changeAllowSchemes();
    },
    //初始化显示数据
    initShowData () {
      let that = this;
      if(this.user.vip){
        if(this.user.payType == 'Lifetime'){
          that.$parent.$refs.leftBanner.menuOptionSelect(901);
          that.$router.push({
            name: "addCloud"
          });
        }
        this.clickIndex = 1;
        }
      let paySysRes = this.$store.getters.getPaySysRes;
      if(paySysRes!=null&&!that.nowScheme){
        //本页面未加载过时加载
        if(paySysRes.nowScheme!={}&&paySysRes.nowScheme!=null&&paySysRes.nowScheme.id){
          //如果非免费用户
          this.setNowScheme(paySysRes);
        }else{
          //免费用户只需要根据条件筛选套餐
          if(paySysRes.vipSchemes){
            this.filterVipSchemes(paySysRes.vipSchemes);
          }
        }
      }
      this.Utils.doSubinquiryPostRequest('get_by_user', { ud: this.user.id }).then(res => {
        //如果请求成功
        that.setNowScheme(res);
        that.$forceUpdate();
        //缓存信息
        that.$store.commit("setPaySysRes", res);
      });
      if(this.user.vip){
        //初始化用户当前信息
        this.getItemSubScrition();
      }
    },
    setMoney(){
      let payMony = this.user.payAmount;
      if (payMony.indexOf("$") == -1) {
        payMony = "$" + payMony;
      }
      return payMony;
    },
    setNowScheme(res){
      if (res.message == 'success' && res.vipSchemes) {
        //根据条件筛选套餐
        this.filterVipSchemes(res.vipSchemes);
        this.user = commonUtils.getUser();
        if(!this.user.vip || res.nowScheme.attrib == 0){
          //如果是老套餐则用
          if (this.user.vip) { //如果不是免费用户
            if (this.user.payLevel > 1) { //大于1为有限，如果为有限月，有限季，有限年用户
              //显示升级的后两项
              this.nowData = this.dataJson.slice(2);
              //计算若选择年无限应该付的金额
              if (this.user.payType == 'Monthly') {
                this.nowData.unshift(this.dataJson[1]);
              } else if (this.user.payType == 'Quarterly') {
                this.nowData.unshift(this.freeOtherPlan[1]);
              } else {
                //有限年套餐去掉无限年
                this.nowData.splice(0,1);
                this.nowData.unshift(this.freeOtherPlan[2]);
              }
              getCurrencyUtils.switchActivityMoneyType(this,'limited');
            } else { //如果为无限
              if (this.user.payType == 'Monthly') { //如果为无限月
                this.nowData = this.dataJson.slice(2, this.dataJson.length);
                this.nowData.unshift(this.monthlyUnlimited);
                getCurrencyUtils.switchActivityMoneyType(this,'UnlimitedMonthly');
              }
              if (this.user.payType == 'Yearly') { //如果为无限年
                this.nowData = this.dataJson.slice(2, this.dataJson.length);
                getCurrencyUtils.switchActivityMoneyType(this,'UnlimitedYearly');
              }
            }
            
            this.nowScheme = {
              type: this.user.payType,
              payMony: this.nowData[0].payMony,
              name: this.nowData[0].paySysName,
              arguments: res.nowScheme.arguments
            };
          } else { //如果用户是免费用户
            this.nowData = this.dataJson;
            this.nowData[0].currentPlan = true;
            getCurrencyUtils.switchActivityMoneyType(this,'free');
          }
        }else{
          this.nowScheme = res.nowScheme;
          let lang = commonUtils.getPriceForLange(localStorage.getItem("locale"));
          this.nowScheme.name = this.$t('language.paySystem.arguments.title.'+res.nowScheme.arguments['title']);
          if(this.nowScheme.isDifferencePrice==1){
            //增值服务显示原价
            this.nowScheme.payMony = this.nowScheme.payMony['basic'][lang];
          }else{
            this.nowScheme.payMony = this.nowScheme.payMony[lang];
          }

        }
      }
    },
    //设置状态和钱
    setStatus () {
    },
    getMorePrivilege () {
      this.morePrivileges = true;
      this.nowData = [this.dataJson[0]];
      this.nowData.push(this.subscriptionTtem);
      if (this.user.payStatus == 'Canceled') {
        this.nowData[1].canceled = true;
        delete this.nowData[1].unsubscribe;
      }
      if (this.user.payStatus == 'Completed') {
        this.nowData[1].unsubscribe = true; //显示取消订阅按钮
        delete this.nowData[1].canceled;
      }
    },
    //获取用户的订阅
    getItemSubScrition (item) {
      this.sendSubScribeRequest = false;
      var subId = this.user.subscrId;
      if(this.user.subscrId.indexOf('-')>0){
          subId = this.user.subscrId.slice(0, this.user.subscrId.indexOf('-'));
      }
      let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
      if(!this.$refs.nowPaySchemeDialog.payInfo){
        return;
      }
      this.$refs.nowPaySchemeDialog.payInfo.subId = subId;
      // this.$refs.nowPaySchemeDialog.source='activity';
      var self = this;
      // this.$nextTick(()=>{
      //   self.$refs.nowPaySchemeDialog.updateItemPreview();
      // });
      this.Utils.doSubinquiryPostRequest('get_by_id', { subscriptionId: subId }).then(res => {
        //如果请求成功
        //item.loading = false;
        if (res.ResultMessage == 'OK') {
          let nowSchemePopup = self.$refs.nowPaySchemeDialog;
          let paymentInfo = res.Subscription.PaymentInfo;

          //获取最新的purchaseId
          let purchaseId = this.getNewPurchaseId(res);

          nowSchemePopup.payInfo.purchaseId = purchaseId;
          nowSchemePopup.payInfo.subId = subId;
          nowSchemePopup.payInfo.nextPayTime = lang=='en'?commonUtils.transferTime(this.user.overTime):commonUtils.transferForMatTime(this.user.overTime);
          nowSchemePopup.getPayInfo();
          if (paymentInfo != null) {
            nowSchemePopup.payInfo.payMethod = paymentInfo.PaymentType;
            nowSchemePopup.payInfo.lastFourNumber = paymentInfo.CardLastFourDigits;
          } else {
            self.getPurchaseV1(purchaseId);
          }
        
        }
      });
    },
    //获取最新的purchaseId
    getNewPurchaseId(res) {
      let newSub = res.Subscription.Items[0];
          if(res.Subscription.Items.length>1){
            let sub;
            for(sub of res.Subscription.Items){
              //isCurrent为true
              if(sub.isCurrent){
                newSub = sub;
                break;
              }
            }
          }
          let newPur = newSub.SubscriptionPurchaseItems[0];
          if(newSub.SubscriptionPurchaseItems.length>1){
            let pur;
            for(pur of newSub.SubscriptionPurchaseItems){
              //id最大
              if(pur.PurchaseId>newPur.PurchaseId){
                newPur = pur;
              }
            }
          }
          return newPur.PurchaseId;
    },
    getPurchaseV1 (purchaseId) {
      var self = this;
      this.Utils.doSubinquiryPostRequest('get_by_purchaseId', { purchaseId: purchaseId }).then(res => {
        //如果请求成功
        if (res.ResultMessage == 'OK') {
          if (res.Purchase.PaidOrderNotification.Purchase.PaymentInfo != null) {
            let paymentInfo = res.Purchase.PaidOrderNotification.Purchase.PaymentInfo;
            self.$refs.nowPaySchemeDialog.payInfo.payMethod = paymentInfo.PaymentType;
          }
        }
      });
    },
     //取消订阅
      unsubscribePlan(item) {
        //取消paypel订阅
        if(this.user.subscrId!=null && this.user.subscrId.startsWith("I")){
        window.open('https://www.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=49QKC8T9BTJDC');
        this.getUserStatus(); //开始检测用户的状态
        return;
        }  
        // 取得要提交页面的URL
        var action = commonstate.cbLinkUrl + this.getUrlType(item.productId) + '/csi/' + this.user.subscrId + '-1?cb_ident=bfa71009';
        commonUtils.addShoppingCartRecords(action, item, this.user, 2);
        // commonUtils.packageFormAndSubmit(action, item, this.user);
        this.getUserStatus(); //开始检测用户的状态
      },
      //获取订阅编号
      getUrlType(productId) {
        let list = ["281158","281174"];
        if(list.includes(productId)) {
            return "/1901";
        }else {
            return "/1533";
        }
      },
      sendGAEvent (item) {
      let that = this;
      if (that.user.vip) {
        //VIP用户升级
        if (item.productId == "214433") {
          googleAnalyticsUtil.pay2(that, "yearly-un3");
        }else
        if (item.productId == "226093") {
          googleAnalyticsUtil.pay2(that, "life-un3");
        }else
        // 流量包
        if (item.productId == "214087") {
          googleAnalyticsUtil.pay2(that, "50g");
        }else
        if (item.productId == "214088") {
          googleAnalyticsUtil.pay2(that, "100g");
        }else{
          googleAnalyticsUtil.pay2(that, item.xPage);
        }
      } else {
        //Free用户订购
        if (item.productId == "214430") {
          googleAnalyticsUtil.pay2(that, "monthly2-0");
        }else
        if (item.productId == "214431") {
          googleAnalyticsUtil.pay2(that, "quarterly2");
        }else
        if (item.productId == "214432") {
          googleAnalyticsUtil.pay2(that, "yearly2");
        }else
        if (item.productId == "214433") {
          googleAnalyticsUtil.pay2(that, "yearly-un2");
        }else
        if (item.productId == "226093") {
          googleAnalyticsUtil.pay2(that, "Life-un2");
        }else{
          googleAnalyticsUtil.pay2(that, item.xPage);
        }
      }
    },
    upgradePlan (item) {
      let that = this;
      //每次打开界面获取的最新用户信息
      that.user = commonUtils.getUser();
      if (!that.user || !that.user.id) {//如果userid不存在则不进行跳转
        that.$toast({
          text: this.$t('language.common.getAccountInfo'),
          type: 'notice',
          idValue: 'rightContBan',
          learnMoreShow: false
        });
        return false;
      }
      commonUtils.refreshUserInfo(this, function (result) {
        that.user = result;
        //ios订单号前四位为2000,而且不是购买流量包
        if(that.user.vip&&(item.xPage!="50gb"&&item.xPage!="100gb")&&(that.user.subscrId.substr(0,2) == "20" || that.user.subscrId.substr(0,1) == "3")){
          //获取ios用户订阅状态
          that.Utils.doSubinquiryPostRequest('get_state_ios', {
            ud: that.user.id,
            salt: that.user.salt
          }).then(response => {
            if(response[0]&&response[0].autoRenewStatus == 1){
              that.$refs.iosPayTipDialog.iosPayTipShow = true;
              that.$refs.iosPayTipDialog.payInfo = {
                name: that.nowScheme.name,
                appleId: response[0].originalTransactionId,
              };
            }else{
              that.openCbPayPage(item);
            }
          })
        }else{
          that.openCbPayPage(item);
        }
      });
    },
    //打开cb支付页面
    openCbPayPage(item) {
      var that = this;
      //检测用户是否绑定邮箱，如果未绑定邮箱则打开绑定邮箱界面
      if (!commonstate.emailpattern.test(that.user.email)) {
        that.sendGAEvent(item);
        paySysUtils.openBindEmailPage(that,item,"paySys");
        return false;
      }
      let lang = commonUtils.getLocaleTo(localStorage.getItem("locale"));
      if (item.type == 'Monthly' && item.xLevel == 2) { //如果点击的是有限月的按钮
        if(that.user.userExpandList&&"auth1"==that.user.userExpandList[0].value) {
            // 如果是auth1用户点击有限月套餐，则直接购买
            //GA打点记录
            googleAnalyticsUtil.pay2(that, "monthly1o-original");
            var action = commonstate.cbLinkUrl + this.getUrlType(item.productId) + '/purl-mc-cart?x-linkid=' + lang + '';
            commonUtils.addShoppingCartRecords(action, item, that.user, 2);
            that.getUserStatus(); //开始检测用户的状态
        }else {
            that.Utils.doUserHaveLoginRequest('getUpShellActiveTime', {
                ud: that.user.id,
                salt: that.user.salt
            }).then(response => {
                var upShellActiveTime = response.upShellActiveTime;
                // let key = 'monthLy' + that.user.id; //计算时间差是否超过了24小时
                let firstTime = upShellActiveTime; //首次点击页面时间
                let nowDateStr = commonUtils.getNowDateFormat();
                let dateTime = nowDateStr.replace(new RegExp("-", "gm"), "/");
                let nowDateLong = new Date(dateTime).getTime(); //现在时间
                let timeDiff;
                let downTime; //倒计时时间
                let page = "monthly2";
                let label1 = "monthly1";
                let label2 = "-0-original";
                if(item.productId=='240889'){
                    page = "monthly2-2";
                    label1 = "monthly2";
                }
                that.getUserStatus(); //开始检测用户的状态
                if (firstTime) {
                    timeDiff = nowDateLong - firstTime;
                    if (timeDiff > 86400000) { //如果超过了24小时
                        // 取得要提交页面的URL
                        label2 = "o-original";
                        //GA打点记录
                        googleAnalyticsUtil.pay2(that, label1+label2);
                        var action = commonstate.cbLinkUrl + '/1533/purl-mc-cart?x-linkid=' + lang + '';
                        commonUtils.addShoppingCartRecords(action, item, that.user, 2);
                        // commonUtils.packageFormAndSubmit(action, item, that.user);
                        that.getUserStatus(); //开始检测用户的状态
                    } else { //进入倒计时界面
                        //GA打点记录
                        googleAnalyticsUtil.pay2(that, label1+label2);
                        downTime = 86400 - parseInt((new Date(dateTime).getTime() - firstTime) / 1000);
                        // let link = '/monthly-unlimited-web.html?id=' + that.user.id + '&time=' + downTime + '&lang=' +
                        //   lang + '&page=monthly1';
                        //新春活动使用monthly3
                        let link = '/monthly-unlimited-web.html?id=' + that.user.id + '&time=' + downTime + '&lang=' +
                            lang + '&page='+page;
                        let language = commonUtils.getLocaleToIndex(that.$i18n.locale);
                        if (language != 'en') {
                            window.open(commonstate.frontEndUrl + '/' + language + link, '_blank');
                        } else {
                            window.open(commonstate.frontEndUrl + link, '_blank');
                        }
                    }
                } else { //进入倒计时界面
                    // localStorage.setItem(key, nowDateLong);
                    //把值存入数据库
                    let changeData = {
                        ud: that.user.id,
                        upShellActiveTime: nowDateLong,
                    }
                    that.Utils.doUserHaveLoginRequest("saveUpShellActiveTime", changeData).then(res => { });
                    let link = '/monthly-unlimited-web.html?id=' + that.user.id + '&time=' + 86400 + '&lang=' + lang + '&page='+page;
                    //'&page=monthly1';新春活动默认为3
                    let language = commonUtils.getLocaleToIndex(that.$i18n.locale);
                    if (language != 'en') {
                        window.open(commonstate.frontEndUrl + '/' + language + link, '_blank');
                    } else {
                        window.open(commonstate.frontEndUrl + link, '_blank');
                    }
                }
                commonUtils.refreshUserInfo(that, function (res) { });
            });
        }
      } else {
        if (that.user.payType && that.user.vip) {
          //如果用户是无限年，即从无限年升级到终身无限版本
          if (that.user.payType == 'Yearly' && that.user.payLevel == 1) {
            //item.payMony = '$ 89.9'; 
            that.$forceUpdate();
          } else if (item.payType == 'Yearly' && item.payLevel == 1) {
            item.loading = true;
            that.$forceUpdate();
            if (!that.sendSubScribeRequest) {//如果已向后端发送了请求则立马返回
              return;
            }
            that.getItemSubScrition(item);
            return;
          }
        }
        that.sendGAEvent(item);
        // 取得要提交页面的URL
        var action = commonstate.cbLinkUrl + this.getUrlType(item.productId) + '/purl-mc-cart?x-linkid=' + lang + '';
        commonUtils.addShoppingCartRecords(action, item, that.user, 2);
        // commonUtils.packageFormAndSubmit(action, item, that.user);
        commonUtils.refreshUserInfo(that, function (res) { });
        that.getUserStatus(); //开始检测用户的状态
      }
    },
    reSubscription (item) {
      // 取得要提交页面的URL
      var action = commonstate.cbLinkUrl + this.getUrlType(item.productId) + '/asi/' + this.user.subscrId + '-1?cb_ident=bfa71009';
      commonUtils.addShoppingCartRecords(action, item, this.user, 2);
      // commonUtils.packageFormAndSubmit(action, item, this.user);
      this.getUserStatus(); //开始检测用户的状态
    },
    getUserStatus () { ///通过获取最新的User判断user是否已经状态改变，如果状态改变则刷新界面
      let oldUser = this.user;
      let that = this;
      let newUser;
      let oldPassword;
      let t;
      this.Utils.doUserHaveLoginRequest('get', {
        ud: oldUser.id,
        salt: oldUser.salt
      }).then(response => {
        that.requestNum = that.requestNum + 1;
        newUser = response.user;
        if (!oldUser.password) {
          delete newUser.password;
        } else {
          oldPassword = oldUser.password;
        }
        that.$store.commit('setPassWord', response.user.password);
        var result = commonUtils.Compare(oldUser, newUser);
        if (that.requestNum == 80) { //如果请求了50次则取消请求
          clearTimeout(t);
          return false;
        }
        if (result != false) { //如果结果是相等则过2秒再进行请求
          t = setTimeout(() => {
            that.getUserStatus();
          }, 2500);
        } else { //如果用户状态已改变
          clearTimeout(t);
          if (oldPassword) {
            newUser.password = oldPassword;
          } else {
            delete newUser.password;
          }
          //that.oldUser = that.user;
          commonUtils.setUserToLocal(newUser);
          commonUtils.setUserCookies(newUser);
          that.$store.commit("setUpdateUserSchems", true);
        if(newUser.vip ){
            if(!(newUser.payType == 'Yearly' && newUser.payLevel >1)){
              localStorage.removeItem("newPayMoney");
              // upgradeItemUtils.getItemPreview(null,function(res){
              // upgradeItemUtils.getItemPreview('halloween',function(result){});
              // if(that.$refs.payDiffDialog.diffShow){
              //   that.$refs.payDiffDialog.loading = false;
              //   that.$refs.payDiffDialog.diffShow=false;
              // }
              // if (!that.morePrivileges) {
              //         that.initShowData();
              // }
              // });
              if (!that.morePrivileges) {
                    that.initShowData();
            } 
            }else{
                 if (!that.morePrivileges) {
                    that.initShowData();
            } 
            }
         }
         if(newUser.vip&&newUser.payStatus=="Canceled"){
           if (!that.morePrivileges) {
                    that.initShowData();
            }
         }
          // 付费升级全局缓存标记
          that.$store.commit("setPayUpgrade", true);
          that.$store.state.normalPayUpgrade=true;
          if (that.$parent && that.$parent.$refs.rightContBan) {
            that.$parent.$refs.rightContBan.funnelShow = false; //不显示漏斗
            //关闭限时购买弹窗后再出现通知信息
            that.$parent.$refs.limitedSaledDialog.timeSaleShow = false;
            that.$parent.$refs.limitedSaledDialog.contentShow = false;
            that.$parent.$refs.limitedSaledDialog.contentUnlimiedShow = false;
            if (that.$parent.$refs.rightContBan.letNotificationsShow) {
              that.$parent.$refs.rightContBan.$refs.notificationsDialog.notificationsShow = true;
              that.$parent.$refs.rightContBan.$refs.notificationsDialog.contentShow = true;
              that.$parent.$refs.rightContBan.letNotificationsShow = false;
              commonUtils.updateViewTime();
            }
            that.$parent.$refs.rightContBan.email = newUser.email;
            that.$parent.$refs.rightContBan.usedTraffic = newUser.usedBytes;
            // if (newUser.vip && newUser.payLevel > 1) {
            //   that.$parent.$refs.rightContBan.usedTraffic = newUser.payUsedTraffic;
            // }
            that.$parent.$refs.rightContBan.totalTraffic = newUser.totalBytes;
            commonUtils.createPayBtn(newUser, that.$parent.$refs.rightContBan);
          }
          that.user = newUser;
          if (newUser.payLevel <= 1) {
            if (newUser.payType == 'Lifetime') {
              that.$parent.$refs.leftBanner.menuOptionSelect(901);
              that.$router.push({
                name: "addCloud"
              });
            }
          }
          if (that.morePrivileges) {
            that.getMorePrivilege();
          } else {
            //本页的页面也应该改变
            if(this.user.vip){
              that.clickIndex = 1;
            }else{
              that.clickIndex = 1;
            }
            that.$forceUpdate();
          }
        }
      });
    },
    backHistory () {
      if (this.morePrivileges) { //让其了解更多为false
        this.morePrivileges = false;
        this.$forceUpdate();
        this.changeChoosePlan(1);
      } else { //返回上一级目录
        history.go(-1);
      }
    },
    checkPaySchemeCycle(){
      if(this.checkCycleType==0){
        this.checkCycleType = 1;
      }else if(this.checkCycleType==1){
        this.checkCycleType = 0;
      }
    },
  }
}
</script>

<style>

.item-sys-right {
  float: left;
  cursor: pointer;
  max-width: 235Px;
}

#paySystem .oldPayMony {
  float: right;
  position: absolute;
  right:40Px;
  font-size: 16Px;
  top: 10Px;
  color: #304dc5;
  text-decoration: line-through;
  font-weight: normal;
}

.item-bottom-right {
  max-width: 300Px;
}

.paySys-body {
  width: 100%;
  box-sizing: border-box;
  padding: 1px;
  height: calc(100% - 90Px);
  position: relative;
  top: 90Px;
  background-color: #f2f7fe;
}

.questionTxtWidth {
  width: 125Px !important;
}

.paysys-box {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
}

/*定义滑块，内阴影及圆角*/
.paysys-box::-webkit-scrollbar {
  width: 8Px;
  /*no*/
  height: 8Px;
  /*no*/
  background-color: #fff;
}

.paysys-box::-webkit-scrollbar-thumb {
  min-height: 5Px;
  /*no*/
  border-radius: 5Px;
  /*no*/
  background-color: #becae4;
}

/* 大标题文字 */
#paySystem .paysys-title {
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #000000;
}

.paySwitch {
  text-align: center;
  position: relative;
  margin-bottom: 40px;
}

.switch-all {
  display: inline-flex;
  width: min-content;
  vertical-align: middle;
  margin: 40px 0px;
  color: #5166bd;
  background-color: #FFFFFF;
  border-radius: 16px;
  user-select: none;
}

.switch-all span {
  margin: 0 25Px;
}

/* 左右按钮 */
#paySystem .switch-left,
#paySystem .seitch-right {
  float: left;
  height: 64px;
  cursor: pointer;
  text-align: center;
  line-height: 64px;
  font-size: 24px;
  font-weight: normal;
  color: #000000;
  white-space: nowrap;
  border-radius: 12px;
}

#paySystem .switch-left {
  margin: 8px 0px 8px 8px;
}

#paySystem .seitch-right {
  margin: 8px 8px 8px 0px;
}

/* 左右选中的按钮 */
#paySystem .switch-click {
  background: #5562B4;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}

.paySys-bottom {
  position: relative;
  text-align: center;
}

.paysys-div {
  width: 300Px;
  border-radius: 20Px;
  height: calc(100% - 20Px);
  float: left;
  box-shadow: -2Px 5Px 8Px 1Px #bababa85;
  /*no*/
  box-sizing: border-box;
  position: relative;
}

.sys-weight-bold {
  font-weight: bold;
}

.paysys-div-all {
  height: 100%;
  margin: auto;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.paysys-div-margin {
  margin-right: 20Px;
}

.paysys-up {
  width: 100%;
  height: 43%;
  float: left;
}

.paysys-down {
  width: 100%;
  height: 57%;
  float: left;
  box-sizing: border-box;
  padding: 15Px 15Px 20Px 15Px;
  position: relative;
}

.paysys-up-title {
  text-align: center;
  font-weight: 400;
  font-size: 24Px;
  color: #1a1a1a;
  margin-top: 6%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}

#paySystem .paysys-up-on {
  height: 50%;
  padding: 0;
  position: relative;
  background-color: #f1f1f1;
  padding-top: 5Px;
  box-sizing: border-box;
}

#paySystem .paysys-up-on:after {
  background-color: #f1f1f1;
  content: '';
  width: 100%;
  height: 30%;
  position: absolute;
  left: 0%;
  top: 84.5%;
  border-radius: 0 0 55% 55%;
}

.paysys-up-purple {
  height: 50%;
  padding: 0;
  position: relative;
  background-color: #dee9fb;
  padding-top: 5Px;
  box-sizing: border-box;
}

.paysys-up-purple:after {
  background-color: #dee9fb;
  content: '';
  width: 100%;
  height: 30%;
  position: absolute;
  left: 0%;
  top: 84.5%;
  border-radius: 0 0 55% 55%;
}

.paysys-up-txt {
  text-align: center;
  font-size: 12Px;
  margin-top: 2%;
  color: rgb(0, 0, 0.6);
}

.paysys-up-price {
  text-align: center;
  top: 50%;
  font-size: 48Px;
  font-weight: bold;
  color: #5562b4;
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
}

#paySystem .paysys-up-payType {
  text-align: center;
  bottom: -6%;
  font-size: 14Px;
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
  color: #304dc5;
}

.paysys-up-down {
  position: relative;
  top: 12%;
  text-align: center;
  width: 100%;
  height: 35%;
}

#paySystem .up-down-payMony {
  font-size: 26Px;
  font-weight: bold;
  color: #304dc5;
}

#paySystem .paysys-property {
  font-size: 14Px;
  height: 15Px;
  text-align: center;
  top: 85%;
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
  color: #304dc5;
}

.paysys-button {
  min-width: 115Px;
  height: 30Px;
  vertical-align: middle;
  display: inline-block;
  text-align: center;
  line-height: 30Px;
  border-radius: 3Px;
  cursor: pointer;
  padding: 0 10Px 0 10Px;
  /* Chrome all / Safari all /opera15+*/ 
-webkit-user-select: none;   
/* Firefox all */  
-moz-user-select: none;     
/* IE 10+ */ 
-ms-user-select: none;       
/* 通用 */
user-select: none;  
}

#paySystem .cborder {
  border: 1Px solid #dee9fb;
  cursor:auto !important;
}

.uborder {
  color: #fff;
}

.paysys-down-des {
  font-weight: bold;
  font-size: 12Px;
  margin-bottom: 15Px;
}

.down-summary-des {
  font-weight: bold;
  font-size: 12Px;
  position: absolute;
  bottom: 10Px;
  margin: 0 auto;
  left: 0;
  right: 0;
}

.paysys-down-line {
  width: 100%;
  font-size: 12Px;
  float: left;
  margin-bottom: 8Px;
}

.down-summary {
  position: absolute;
  bottom: 0;
  margin-bottom: 10Px;
}

.downs-summarys {
  float: left;
  width: 100%;
  height: 20Px;
  text-align: center;
}

.up-down-center {
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 30Px;
}

.down-des-for {
  margin-left: 10Px;
  float: left;
}

.paysys-all {
  width: 1250px;
  margin: 80px auto 60px auto;
  position: relative;
}


.paysys-all::after {
  content: "";
  display: block;
  clear: both;
}

.sys-questionTxt {
  width: 200Px;
  display: none;
  position: absolute;
  border: 1Px solid #5562b4;
  border-radius: 3Px;
  left: 20Px;
  top: 2Px;
  background: #fff;
  z-index: 3;
  font-size: 12Px;
  box-sizing: border-box;
  padding: 5Px;
  line-height: 20Px;
}

.sys-bottomTxt {
  width: 160Px;
  display: none;
  position: absolute;
  border: 1Px solid #5562b4;
  border-radius: 3Px;
  left: 20Px;
  bottom: 0Px;
  background: #fff;
  z-index: 3;
  font-size: 12Px;
  box-sizing: border-box;
  padding: 5Px;
  line-height: 20Px;
  font-weight: 100;
}

.plan-question:hover .sys-questionTxt,
.plan-question:hover .sys-bottomTxt {
  display: block;
}

.current-month {
  font-weight: bold;
  margin-bottom: 15Px;
}

.current-box {
  width: 770Px;
  height: 15Px;
  border: 1Px solid #a9baff;
  vertical-align: middle;
  margin: auto;
  text-align: center;
  font-size: 14Px;
  position: relative;
  margin-bottom: 40Px;
}

#paySystem .sys-progress-bar {
  background-color: #5562b4;
  height: 100%;
  max-width: 100%;
  text-align: center;
}

.sys-traffic {
  position: absolute;
  left: 0;
  right: 0;
  top: -1Px;
}

.current-plan {
  width: 270Px;
  height: calc(100% - 20Px);
  -webkit-box-shadow: -2Px 5Px 8Px 0.1Px #bababa85;
  box-shadow: -2Px 5Px 8Px 0.1Px #bababa85;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 250Px;
  float: left;
}

#paySystem .paysys-expir {
  font-size: 14Px;
  height: 15Px;
  text-align: center;
  bottom: -25Px;
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
  color: #304dc5;
}

.current-plans {
  vertical-align: middle;
  margin: auto;
  height: 300Px;
}

.current-plan-purple {
  height: 110Px;
  padding: 0;
  position: relative;
  background-color: #dee9fb;
  padding-top: 5Px;
  box-sizing: border-box;
}

.current-plan-purple:after {
  background-color: #dee9fb;
  content: '';
  width: 100%;
  height: 20Px;
  position: absolute;
  left: 0%;
  top: 110Px;
  border-radius: 0 0 55% 55%;
}

.current-plan-paySysName {
  margin-top: 20Px;
  font-weight: bold;
  font-size: 20Px;
}

.plan-paySysName-bottom {
  position: absolute;
  z-index: 3;
  margin: auto;
  left: 0;
  right: 0;
  top: 86%;
}

.up-down-eachGb {
  font-size: 12Px;
  margin: 5Px 0 0 0;
}

.lItem-summary {
  font-size: 12Px;
  width: 155Px;
  margin: auto;
  vertical-align: middle;
  position: relative;
  top: 13Px;
  line-height: 15Px;
}

.grey-hr {
  width: calc(100% - 40Px);
  height: 1Px;
  border-bottom: 1Px solid#F6F6F6;
  vertical-align: middle;
  margin: auto;
  float: left;
  margin-left: 20Px;
}

.sysLink:hover {
  text-decoration: underline;
}

.morePrivileges-bottom {
  position: relative;
  top: 25Px;
  height: 500Px;
}

.paySys-bottom-unlimit {
  top: 8Px;
}

.paySys-bottom-tips{
  position: relative;
  top: 70Px;
}
.paySys-up-margin {
  top: 20Px;
}

.special-up {
  color: #fff;
  width: 100%;
  height: 30Px;
  text-align: center;
  position: absolute;
  z-index: 3;
  top: -20Px;
  line-height: 30Px;
}

.plan-pay-check {
  width: 20Px;
  /*no*/
  height: 16Px;
  /*no*/
  background-position: -1270Px -205Px;
  /*no*/
}

.bottom-des-txt {
  line-height: 17Px;
}

.back-en {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_en.png')
    no-repeat center center;
}

.back-de {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_de.png')
    no-repeat center center;
}

.back-fr {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_fr.png')
    no-repeat center center;
}

.back-por {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_pt.png')
    no-repeat center center;
}

.back-spa {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_es.png')
    no-repeat center center;
}

.back-it {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_it.png')
    no-repeat center center;
}

.back-ja {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_jp.png')
    no-repeat center center;
}

.back-tw {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_tw.png')
    no-repeat center center;
}

.back-cn {
  background: url('../../assets/images/workspace/SpecialOffer/label_SpecialOffer_cn.png')
    no-repeat center center;
}

.plan-two-button .el-loading-spinner .circular {
  height: 0.25rem !important;
  width: 0.25rem !important;
  position: relative;
  top: 30Px;
}

.plan-two-button .el-loading-mask {
  background-color: #fc8123 !important;
  border-radius: 2Px;
  z-index: 10 !important;
}

.plan-two-button .el-loading-spinner .path {
  stroke: #ffffff !important;
}

/* 波浪 */
.pay_task_buttom {
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
}

/* 返回箭头 */
.sys_back_icon {
  width: 48px;
  height: 48px;
  background-image: url("../../assets/images/paySystem/back.svg");
  cursor: pointer;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
}
.sys_back_icon:hover {
  background-image: url("../../assets/images/paySystem/backHover.svg");
}
.sys_back_icon:active {
  background-image: url("../../assets/images/paySystem/backHover.svg");
  opacity: 0.8;
}

/* 切换年月 */
.paysys-cycle {
  height: 28px;
  line-height: 28px;
  user-select: none;
}
/* 切换里面的元素 */
.paysys-cycle>div {
  display: inline-block;
  vertical-align: middle;
}
/* 月 */
.cycle-name {
  width: 410px;
  text-align: right;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
}
/* 年 */
.cycle-name-right {
  width: 400px;
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
}
/* 选中文字样式 */
.check-cycle {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
/* 切换 */
.pay-scheme-cycle-btn {
  float: none;
  margin: 0px 16px;
}
/* 优惠 */
.cycle-name-tips {
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
  border-radius: 2px;
  background: #FF6C19;
  height: 16px;
  line-height: 16px;
  margin: 6px;
  padding: 0 6px;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/pay_system.vue